// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"23e5a67c","453":"66245082"}[chunkId] + ".chunk.js";
};